<template>
    <section class="container-fluid header-list-type-2" v-if="!loading">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="wrp">
                        <div class="content">
                            <router-link :to="{ name: 'audiences' }" class="back-link-type-1">
                                <div class="p">{{$t('views.audience.buttons.back')}}</div>
                            </router-link>
                            <h1 class="name">{{ audience.name || '-' }}</h1>
                            <p v-html="$t('views.audience.description', { total: formatNumber(audience.stats.suspects || audience.total), date: epochToDisplayDate(audience.changed_time || '01-01-1970')})"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAudienceStore } from '@/stores/audience';
    import { epochToDisplayDate } from '@/utils/dates';
    import { formatNumber } from '@/utils/formatting';

    export default {
        name: "AudiencesHeader",
        computed: {
            ...mapState(useAudienceStore, ['audience', 'loading']),
        },
        methods: {
            epochToDisplayDate,
            formatNumber
        }
    }
</script>